import { _axios } from "../axios";
import {AxiosResponse} from "axios";

/**
 *
 * @param productSlug
 * @param kit
 * @returns {Promise<AxiosResponse<any>>}
 */
export function saveKit( productSlug = '', kit = {}) {
    return _axios.post( '/kits/', { kit: kit } );
}